import api from "@/services/api";

interface WithdrawRequest {
  value: number;
  password: string;
}

class WithdrawTransaction {
  execute = async (value: number, password: string) => {
    const payload: WithdrawRequest = {
      value: value,
      password: password,
    };

    const response = await api().post(`/transaction/withdrawal`, payload);
    return response.data;
  };
}

export { WithdrawTransaction };
